import { setupSwiper } from "../utils/swiper-setup";

document.addEventListener("DOMContentLoaded", () => {
  const projectModules = document.querySelectorAll(
    ".component__latest-projects",
  );
  projectModules.forEach((module) => {
    const swiper = module.querySelector(".swiper");
    if (swiper) {
      setupSwiper(swiper.id, {
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
          el: module.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: module.querySelector(".swiper-button-next"),
          prevEl: module.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      });
    }
  });
});
